import * as actionTypes from '../constants/actionTypes';
import SubscriptionsApi from '../api/subscriptions/subscriptionsApi';

export function showModal() {
  return { type: actionTypes.SUBSCRIPTION_MODAL_SHOW };
}

export function hideModal() {
  return { type: actionTypes.SUBSCRIPTION_MODAL_HIDE };
}

export function subscribe(email) {
  return dispatch => {
    dispatch({type: actionTypes.SUBSCRIPTION_CREATE, email});

    return SubscriptionsApi.create(email)
      .then(() => { return dispatch(createSubsctiptionSuccess());})
      .catch(err => { dispatch(createSubscriptionFailure(err)); throw err;});
  };
}

export function createSubsctiptionSuccess() {
  return { type: actionTypes.SUBSCRIPTION_CREATE__SUCCESS };
}

export function createSubscriptionFailure(err) {
  return { type: actionTypes.SUBSCRIPTION_CREATE__FAILURE, err };
}



// WEBPACK FOOTER //
// ./src/actions/subscriptionActions.js